import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import DetailsKV from "@eres/ejari-web/component/DetailsKV";
import { LocaleUtil } from "@eres/core";
import { Terms } from "../../../../apis/privatesell/enitites";
import { FormContainer } from "../Base";

interface Props {
	terms?: Terms[];
}

export default class ViewTerms extends Component<Props> {
	render() {
		const terms = this.props.terms!;
		return <FormContainer title={ Strings.terms_and_conditions }>
			<div className="flex-grid flex-full">
				{
					terms.map( ( term ) => {
						return <DetailsKV label={ LocaleUtil.getLocalValue( term.title ) } value={ LocaleUtil.getLocalValue( term.description ) }/>;
					} )
				}
			</div>
		</FormContainer>;
	}
}
